/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { User2 } from '../../models/user-2';

export interface GetApi$Params {
}

export function getApi(http: HttpClient, rootUrl: string, params?: GetApi$Params, context?: HttpContext): Observable<StrictHttpResponse<User2>> {
  const rb = new RequestBuilder(rootUrl, getApi.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<User2>;
    })
  );
}

getApi.PATH = '/api/v1/me';
